import CausesRejectedFormatter from 'src/views/Pages/Dashboard/Rejected/CausesRejectionsCategories/CausesRejectedFormatter.vue';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'cause_rejected_clusters',
      label: i18n.t('production.motive'),
      minWidth: 150,
      sortable: true,
      formatter: CausesRejectedFormatter,
      show: false,
    },
  ];

  return { tableColumns };
};

export default configTable;